import { push } from 'connected-react-router';
import ActionTypes from './ActionTypes';
import Alert from 'react-s-alert';
import { Messages, ApportionmentType } from '../constants';
import {
  NegotiationService,
  NotificationService,
  AdvertiserService,
  NatureService,
  SaleTypeService,
  PriceTableService,
  PaymentTypeService,
  VehicleService,
  SalesOriginService,
  CommercialPlanService,
  ExecutiveService,
  ComprehensiveneService,
  AuthenticationService
} from '../services';

export const redirectToAddNegotiation = () => dispatch =>
  dispatch(push('/negociacoes/cadastro'));

export const redirectToNegoationList = () => async dispatch => {
  dispatch({
    type: ActionTypes.CLEAR_NEGOTIATION
  });
  dispatch(push('/negociacoes'));
};

export const redirectToSelectComprehennsiveness = (t) => dispatch => {
  dispatch({
    type: ActionTypes.SHOW_SELECT_COMPREHENSIVENESS,
  });
  dispatch(push('/negociacoes/cadastro/abrangencia/'));

};

export const hiddenSelectComprehensiveness = (revoke = false) => dispatch => {
  if (revoke)
    dispatch({
      type: ActionTypes.REVOKE_SELECT_COMPREHENSIVENESS
    });
  dispatch(push('/negociacoes/cadastro'));
};

export const userIsNotExecutive = () => dispatch => {
  Alert.error(Messages.UserIsNotExecutive);
  dispatch(push('/negociacoes'));
};

export const sortNegotiationList = (
  column,
  direction,
  executive,
  registerPerPage,
  search = ''
) => dispatch => {
  dispatch({
    type: ActionTypes.SORT_NEGOTIATION_LIST,
    payload: { column, direction }
  });
  searchNegotiations(executive, registerPerPage, search, column, direction)(
    dispatch
  );
};

export const saveNegotiation = (
  negotiation,
  clientSearch,
  loggedUser,
  userName,
) => async dispatch => {
  try {
    const token = await AuthenticationService.getLoggedUser();
    let isNewCliente = false;

    if (!negotiation.client) {
      const clienteSearchOnlyNumbers = clientSearch ? clientSearch.trim() : clientSearch;
      const client = await AdvertiserService.searchClients(clienteSearchOnlyNumbers, token);

      if (!client || client.length <= 0) {
        isNewCliente = true;
        dispatch({ type: ActionTypes.SAVE_CLIENT });
        const newClient = await AdvertiserService.saveClient(
          clienteSearchOnlyNumbers,
          negotiation.agency,
          negotiation.paymentType,
          token,
          negotiation.totalAmount,
          negotiation.beginDate,
          negotiation.endDate
        );
        dispatch({ type: ActionTypes.SAVE_CLIENT_SUCCESS });
        negotiation = { ...negotiation, client: newClient };
      }

      if (!negotiation.client)
      negotiation = { ...negotiation, client: client[0] };
    }

    dispatch({ type: ActionTypes.SAVE_NEGOTIATION });
    const savedNegotiation = await NegotiationService.save(negotiation, token, isNewCliente, loggedUser, userName);
    dispatch({
      type: ActionTypes.SAVE_NEGOTIATION_SUCCESS,
      payload: savedNegotiation
    });
    Alert.success(Messages.NegotiationSuccessSave);
    dispatch(push('/negociacoes'));
  } catch (e) {
    dispatch({ type: ActionTypes.SAVE_CLIENT_FAIL });
    dispatch({ type: ActionTypes.SAVE_NEGOTIATION_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const updateNegotiationField = ({ prop, value }) => ({
  type: ActionTypes.UPDATE_NEGOTIATION_EDIT_FIELD,
  payload: { prop, value }
});

export const checkedComprehensiveness = comprehensiveness => ({
  type: ActionTypes.CHECKED_COMPREHENSIVENESS,
  payload: comprehensiveness
});



export const uncheckedComprehensiveness = comprehensiveness => ({
  type: ActionTypes.UNCHECKED_COMPREHENSIVENESS,
  payload: comprehensiveness
});

export const updateInputFilter = search => ({
  type: ActionTypes.UPDATE_INPUT_FILTER,
  payload: search
});

export const changedRegion = (region) => dispatch => {
  dispatch({
    type: ActionTypes.CHANGED_REGION,
    payload: region
  });
};

export const unChangedRegion = (region) => dispatch => {
  dispatch({
    type: ActionTypes.UNCHANGED_REGION,
    payload: region
  });
};

export const clearAgencyOptions = () => ({
  type: ActionTypes.CLEAR_AGENCY_OPTIONS
});

export const clearClientOptions = () => ({
  type: ActionTypes.CLEAR_CLIENT_OPTIONS
});

export const closeApportionment = () => async dispatch => {
  dispatch(push('/negociacoes/cadastro'));
};

export const changedClienteSearch = search => async dispatch => {
  dispatch({ type: ActionTypes.CHANGED_CLIENT_SEARCH, payload: search });
};

export const updateClientOptions = search => async dispatch => {
  try {
    const token = await AuthenticationService.getLoggedUser();
    dispatch({
      type: ActionTypes.UPDATE_NEGOTIATION_CLIENT_OPTIONS
    });
    const negotiations = await AdvertiserService.searchClients(search, token);
    dispatch({
      type: ActionTypes.UPDATE_NEGOTIATION_CLIENT_OPTIONS_SUCCESS,
      payload: negotiations
    });
  } catch (e) {
    dispatch({ type: ActionTypes.UPDATE_NEGOTIATION_CLIENT_OPTIONS_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const selectedClient = client => ({
  type: ActionTypes.SELECTED_CLIENT,
  payload: client
});

export const selectedAgency = agency => ({
  type: ActionTypes.SELECTED_AGENCY,
  payload: agency
});

export const changedAgencySearch = search => async dispatch => {
  dispatch({ type: ActionTypes.CHANGED_AGENCY_SEARCH, payload: search });
};

export const updateAgencyOptions = search => async dispatch => {
  try {
    const token = await AuthenticationService.getLoggedUser();
    dispatch({
      type: ActionTypes.UPDATE_NEGOTIATION_AGENCY_OPTIONS
    });
    const agencies = await AdvertiserService.searchAgencies(search, token);
    dispatch({
      type: ActionTypes.UPDATE_NEGOTIATION_AGENCY_OPTIONS_SUCCESS,
      payload: agencies
    });
  } catch (e) {
    dispatch({ type: ActionTypes.UPDATE_NEGOTIATION_AGENCY_OPTIONS_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillNatures = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_NATURES });
    const natures = await NatureService.search();
    dispatch({
      type: ActionTypes.FILL_NATURES_SUCCESS,
      payload: natures
    });
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_NATURES_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillToken = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_TOKEN });
    const token = await AuthenticationService.getLoggedUser();
    dispatch({
      type: ActionTypes.FILL_TOKEN_SUCCESS,
      payload: token
    });
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_TOKEN_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillComprehensiveness = (t) => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_COMPREHENSIVENESS });

    const comprehensiveness = await ComprehensiveneService.search(t);
    const ufs = comprehensiveness.map(c => c.estado).filter((x, i, a) => a.indexOf(x) == i).sort();
    const region = comprehensiveness.map(c => c.regiao).filter((x, i, a) => a.indexOf(x) == i).sort();
    dispatch({
      type: ActionTypes.FILL_COMPREHENSIVENESS_SUCCESS,
      payload: comprehensiveness
    });
    dispatch({
      type: ActionTypes.FILL_UFS,
      payload: ufs
    });
    dispatch({
      type: ActionTypes.FILL_REGION,
      payload: region
    });
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_COMPREHENSIVENESS_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};



export const fillpriceTable = (id) => async dispatch => {
  try {

    dispatch({ type: ActionTypes.FILL_PRICE_TABLE });
    const priceTables = await PriceTableService.search(id);
    dispatch({
      type: ActionTypes.FILL_PRICE_TABLE_SUCCESS,
      payload: priceTables
    });
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_PRICE_TABLE_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillPaymentTypes = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_PAYMENT_TYPES });
    const paymentTypes = await PaymentTypeService.search();
    dispatch({
      type: ActionTypes.FILL_PAYMENT_TYPES_SUCCESS,
      payload: paymentTypes
    });
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_PAYMENT_TYPES_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillCommercialPlans = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_COMMERCIAL_PLANS });
    const paymentTypes = await CommercialPlanService.searchAll();
    dispatch({
      type: ActionTypes.FILL_COMMERCIAL_PLANS_SUCCESS,
      payload: paymentTypes
    });
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_COMMERCIAL_PLANS_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillMainVehicles = type  => async dispatch => {
  try{
    let mainVehicles = await VehicleService.search();
    dispatch({
      type: ActionTypes.FILL_MAINVEHICLES,
      payload: mainVehicles
    });

  }catch(e){
    NotificationService.showApiResponseErrorAlert(e);
  }
}

export const updateSalesOrigin = (id) => async dispatch => {
  let ValueSalesOrigin = await SalesOriginService.search(id);
  dispatch({
    type: ActionTypes.UPDATE_SALESORIGIN,
    payload: ValueSalesOrigin
  });
};
export const updateMainVehicle = (id) => async dispatch => {
  dispatch({
    type: ActionTypes.UPDATE_MAINVEHICLE,
    payload: id
  });
};

export const fillVehicles = type => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_VEHICLES });
    let vehicles = await VehicleService.search();
/*     if (vehicles) {
      vehicles =
        type === ApportionmentType.Digital
          ? vehicles.filter(v => v.id === 51)
          : vehicles.filter(v => v.id !== 51);
    } */
    dispatch({
      type: ActionTypes.FILL_VEHICLES_SUCCESS,
      payload: vehicles
    });

    if (vehicles && vehicles.length === 1 && vehicles[0].id === 51) {
      dispatch({
        type: ActionTypes.SELECT_VEHICLES_TYPE,
        payload: vehicles[0]
      });
    }
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_VEHICLES_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};


export const fillSalesOrigin = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_SALESORIGIN_TYPE });
    const token = await AuthenticationService.getLoggedUser();
    const valueSalesOrigin = await SalesOriginService.search(token.profile.sub);
    dispatch({
      type: ActionTypes.FILL_SALESORIGIN_TYPE_SUCCESS,
      payload: valueSalesOrigin
    });
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_SALESORIGIN_TYPE_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillSalesTypes = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_SALES_TYPE });
    const salesType = await SaleTypeService.search();
    dispatch({
      type: ActionTypes.FILL_SALES_TYPE_SUCCESS,
      payload: salesType
    });
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_SALES_TYPE_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const fillExecutive = executive => async dispatch => {
  dispatch({
    type: ActionTypes.FILL_EXECUTIVE_SUCCESS,
    payload: executive
  });
};

export const unCheckedUfs = region => async dispatch => {
  dispatch({
    type: ActionTypes.UNCHECKEDS_UFS,
    payload: region
  });
};

export const checkedUfs = region => async dispatch => {
  dispatch({
    type: ActionTypes.CHECKEDS_UFS,
    payload: region
  });
};

export const ChangeValueSharepointSave = save => async dispatch => {
  dispatch({
    type: ActionTypes.CHANGE_SAVE_SHAREPOINT,
    payload: save
  });
};

export const InputTextSharepoint = text => async dispatch => {
  dispatch({
    type: ActionTypes.CHANGE_TEXT_SHAREPOINT,
    payload: text
  });
};
export const uncheckedNacional = nacional => async dispatch => {
  dispatch({
    type: ActionTypes.UNCHECKED_NACIONAL,
    payload: nacional
  });
};

export const checkedNacional = nacional => async dispatch => {
  dispatch({
    type: ActionTypes.CHECKED_NACIONAL,
    payload: nacional
  });
};

export const searchNegotiations = (
  executive,
  registerPerPage,
  search = '',
  column = '',
  direction = ''
) => async dispatch => {
  try {
    dispatch({ type: ActionTypes.SEARCH_NEGOTIATIONS });
    const negotiations = await NegotiationService.search(
      executive,
      registerPerPage,
      search,
      column,
      direction
    );
    dispatch({
      type: ActionTypes.SEARCH_NEGOTIATIONS_SUCCESS,
      payload: negotiations
    });
  } catch (e) {
    dispatch({ type: ActionTypes.SEARCH_NEGOTIATIONS_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const searchAllNegotiations = (
  executive,
  search,
  column,
  direction
) => async dispatch => {
  try {
    const maxRegisters = process.env.REACT_APP_MAX_REGISTER_PER_PAGE;
    dispatch({ type: ActionTypes.SEARCH_ALL_NEGOTIATIONS });
    const negotiations = await NegotiationService.search(
      executive,
      maxRegisters,
      search,
      column,
      direction
    );
    dispatch({
      type: ActionTypes.SEARCH_ALL_NEGOTIATIONS_SUCCESS,
      payload: { negotiations, registerPerPage: maxRegisters }
    });
  } catch (e) {
    dispatch({ type: ActionTypes.SEARCH_ALL_NEGOTIATIONS_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const redirectToDetail = id => async dispatch => {
  try {
    dispatch({ type: ActionTypes.FILL_NEGOTIATION_DETAIL });
    const negotiation = await NegotiationService.get(id);
    console.log(negotiation)
    dispatch({
      type: ActionTypes.FILL_NEGOTIATION_DETAIL_SUCCESS,
      payload: negotiation
    });
    dispatch(push('/negociacoes/detalhe'));
  } catch (e) {
    dispatch({ type: ActionTypes.FILL_NEGOTIATION_DETAIL_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const redirectToRegister = type => async dispatch => {
  dispatch({
    type: ActionTypes.REDIRECT_TO_REGISTER_APPORTIONMENT,
    payload: type
  });
  dispatch({
    type: ActionTypes.UPDATE_REMAINING_VALUE
  });
};

export const addApportioment = apportioment => async dispatch => {
  dispatch({
    type: ActionTypes.SAVE_APPORTIOMENT,
    payload: apportioment
  });
};

export const fillApportionment = apportioment => async dispatch => {
  dispatch({
    type: ActionTypes.FILL_APPORTIOMENT,
    payload: apportioment
  });
};

export const removeApportionment = apportioment => async dispatch => {
  dispatch({
    type: ActionTypes.REMOVE_APPORTIOMENT,
    payload: apportioment
  });
};

export const redirectToApportioment = () => async dispatch => {
  dispatch({
    type: ActionTypes.UPDATE_REMAINING_VALUE
  });
  dispatch({
    type: ActionTypes.CLEAR_APPORTIOMENT_FIELDS
  });
};

export const updateApportionmentField = ({ prop, value }) => async dispatch => {
  dispatch({
    type: ActionTypes.UPDATE_APPORTIONMENT_FIELD,
    payload: { prop, value }
  });
};



export const clearDigital = () => async dispatch => {
  dispatch({
    type: ActionTypes.CLEAR_DIGITAL
  });
};

export const clearOtherVehicles = () => async dispatch => {
  dispatch({
    type: ActionTypes.CLEAR_OTHERS_VEHICLES
  });
};


export const updateApportionmentAmountField = ({
  prop,
  value,
  totalAmount
}) => async dispatch => {
  const amountValue =
    Math.round(
      (prop === 'amount' ? value : (totalAmount * value) / 100) * 100
    ) / 100;
  const percentvalue =
    Math.round(
      (prop === 'percent' ? value : (value * 100) / totalAmount) * 100
    ) / 100;
  dispatch({
    type: ActionTypes.UPDATE_APPORTIONMENT_AMOUNT_FIELD,
    payload: { amountValue, percentvalue }
  });
};
